webpackJsonp([59],{

/***/ "Bx9n":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".privacy-agreement[data-v-5d0fcf96]{background:#fff;width:1200px;margin:20px auto;padding:30px 50px;min-height:800px}.privacy-agreement__title[data-v-5d0fcf96]{text-align:center;font-family:PingFangSC-Medium;font-weight:700;font-size:18px;color:#333;line-height:25px;margin-bottom:20px}.privacy-agreement__header[data-v-5d0fcf96]{font-family:PingFangSC-Medium;font-weight:700;font-size:14px;color:#333;letter-spacing:0;line-height:26px;margin-bottom:13px}.privacy-agreement__time[data-v-5d0fcf96]{display:inline-block;margin-right:30px}.privacy-agreement__sub-title[data-v-5d0fcf96]{text-align:center;font-size:16px;margin-top:20px}.privacy-agreement__sub-title[data-v-5d0fcf96],.privacy-agreement b[data-v-5d0fcf96]{font-family:PingFangSC-Medium;font-weight:700;color:#4a4a4a;letter-spacing:0;line-height:20px;margin-bottom:10px}.privacy-agreement b[data-v-5d0fcf96]{font-size:14px}.privacy-agreement p[data-v-5d0fcf96]{font-family:PingFangSC-Regular;font-size:14px;color:#4a4a4a;letter-spacing:0;line-height:20px;margin-bottom:10px}.privacy-agreement .text-style[data-v-5d0fcf96]{color:#333;font-weight:700}.privacy-agreement .artical-preface[data-v-5d0fcf96]{margin-bottom:7px;font-size:13px;color:#666}", "", {"version":3,"sources":["/home/work/jenkins/workspace/FD-FE_hfsfd-student/src/views/index/components/ChildPrivaryPolicy.vue"],"names":[],"mappings":"AAGA,oCACE,gBAAiB,AACjB,aAAc,AACd,iBAAkB,AAClB,kBAAmB,AACnB,gBAAkB,CACnB,AACD,2CACI,kBAAmB,AACnB,8BAA+B,AAC/B,gBAAkB,AAClB,eAAgB,AAChB,WAAe,AACf,iBAAkB,AAClB,kBAAoB,CACvB,AACD,4CACI,8BAA+B,AAC/B,gBAAkB,AAClB,eAAgB,AAChB,WAAe,AACf,iBAAkB,AAClB,iBAAkB,AAClB,kBAAoB,CACvB,AACD,0CACI,qBAAsB,AACtB,iBAAmB,CACtB,AACD,+CACI,kBAAmB,AAGnB,eAAgB,AAIhB,eAAiB,CAEpB,AACD,qFATI,8BAA+B,AAC/B,gBAAkB,AAElB,cAAe,AACf,iBAAkB,AAClB,iBAAkB,AAElB,kBAAoB,CAUvB,AARD,sCAGI,cAAgB,CAKnB,AACD,sCACI,+BAAgC,AAChC,eAAgB,AAChB,cAAe,AACf,iBAAkB,AAClB,iBAAkB,AAClB,kBAAoB,CACvB,AACD,gDACI,WAAY,AACZ,eAAkB,CACrB,AACD,qDACI,kBAAmB,AACnB,eAAgB,AAChB,UAAY,CACf","file":"ChildPrivaryPolicy.vue","sourcesContent":["\n@charset \"UTF-8\";\n/*颜色库*/\n.privacy-agreement[data-v-5d0fcf96] {\n  background: #fff;\n  width: 1200px;\n  margin: 20px auto;\n  padding: 30px 50px;\n  min-height: 800px;\n}\n.privacy-agreement__title[data-v-5d0fcf96] {\n    text-align: center;\n    font-family: PingFangSC-Medium;\n    font-weight: bold;\n    font-size: 18px;\n    color: #333333;\n    line-height: 25px;\n    margin-bottom: 20px;\n}\n.privacy-agreement__header[data-v-5d0fcf96] {\n    font-family: PingFangSC-Medium;\n    font-weight: bold;\n    font-size: 14px;\n    color: #333333;\n    letter-spacing: 0;\n    line-height: 26px;\n    margin-bottom: 13px;\n}\n.privacy-agreement__time[data-v-5d0fcf96] {\n    display: inline-block;\n    margin-right: 30px;\n}\n.privacy-agreement__sub-title[data-v-5d0fcf96] {\n    text-align: center;\n    font-family: PingFangSC-Medium;\n    font-weight: bold;\n    font-size: 16px;\n    color: #4A4A4A;\n    letter-spacing: 0;\n    line-height: 20px;\n    margin-top: 20px;\n    margin-bottom: 10px;\n}\n.privacy-agreement b[data-v-5d0fcf96] {\n    font-family: PingFangSC-Medium;\n    font-weight: bold;\n    font-size: 14px;\n    color: #4A4A4A;\n    letter-spacing: 0;\n    line-height: 20px;\n    margin-bottom: 10px;\n}\n.privacy-agreement p[data-v-5d0fcf96] {\n    font-family: PingFangSC-Regular;\n    font-size: 14px;\n    color: #4A4A4A;\n    letter-spacing: 0;\n    line-height: 20px;\n    margin-bottom: 10px;\n}\n.privacy-agreement .text-style[data-v-5d0fcf96] {\n    color: #333;\n    font-weight: bold;\n}\n.privacy-agreement .artical-preface[data-v-5d0fcf96] {\n    margin-bottom: 7px;\n    font-size: 13px;\n    color: #666;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "I1ew":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy-agreement-page"},[_c('app-header'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy-agreement"},[_c('h2',{staticClass:"privacy-agreement__title"},[_vm._v("好分数辅导儿童隐私政策")]),_vm._v(" "),_c('div',{staticClass:"privacy-agreement__header"},[_c('span',{staticClass:"privacy-agreement__time"},[_vm._v("版本更新日期: 2021年6月9日")]),_vm._v(" "),_c('span',{staticClass:"privacy-agreement__time"},[_vm._v("本政策生效日期: 2021年6月9日")])]),_vm._v(" "),_c('p',{staticClass:"artical-preface"},[_vm._v("\n            好分数辅导（或简称“我们”）深知保护儿童（指未满十四周岁的未成年人，下同）个人信息安全和隐私的重要性。在《隐私政策》的基础上，我们希望通过《儿童隐私政策》（以下简称“本政策”）说明我们在收集和使用儿童个人信息时对应的处理规则等相关事宜。\n            "),_c('span',{staticClass:"text-style"},[_vm._v("您作为您孩子的父母或其他监护人（以下统称为“监护人”），请在您或您的孩子使用好分数辅导的产品及服务前，务必仔细阅读并透彻理解本政策，在确认充分理解并同意全部条款后再开始使用或允许您的孩子使用。")])]),_vm._v(" "),_c('p',[_vm._v("监护人特别说明：")]),_vm._v(" "),_c('p',[_vm._v("\n            您的理解和配合对我们保护您孩子的个人信息和隐私安全非常必要，为了维护您孩子的合法权益，我们希望您可以协助我们，确保您的孩子在您的同意和指导下使用我们的产品及服务和向我们提交个人信息。我们将根据本政策采取特殊措施保护我们获得的您孩子的个人信息。\n            "),_c('span',{staticClass:"text-style"},[_vm._v("如果您不同意本政策的内容，请您要求您的孩子立即停止访问/使用我们的产品及服务。")])]),_vm._v(" "),_c('p',[_vm._v("儿童特别说明：")]),_vm._v(" "),_c('p',[_vm._v("\n            任何儿童参加网上活动都应事先取得监护人的同意。如果您是儿童，请务必通知您的监护人共同阅读本政策，并在您使用我们的产品及服务、提交个人信息之前，寻求您的监护人的同意和指导。\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            本政策适用于我们在中华人民共和国境内通过网络从事收集、存储、使用、转移、分享和披露儿童个人信息等活动。本政策为在《隐私政策》基础上制定的特别规则，与《隐私政策》如有不一致之处，以本政策为准；本政策未载明之处，则参照适用《隐私政策》。\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            在您阅读完本政策后，如对本政策或与本政策相关的事宜有任何问题，可通过文末所列的反馈渠道联系我们，我们会尽快为您作出解答。\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            本政策将帮助您了解以下内容：\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            一、我们如何收集和使用儿童个人信息\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            二、我们如何共享、转让、公开披露儿童个人信息\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            三、我们如何储存儿童个人信息\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            四、我们如何保护儿童个人信息\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            五、如何管理儿童个人信息\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            六、本政策的修订\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            七、如何联系我们\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            一、我们如何收集和使用儿童个人信息\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            （一）我们会严格履行法律法规规定的儿童个人信息保护义务与责任，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，在征得监护人的同意后收集和使用儿童个人信息。\n            "),_c('span',{staticClass:"text-style"},[_vm._v("您在使用我们的产品或服务中主动向我们提供您孩子的个人信息。")])]),_vm._v(" "),_c('p',[_vm._v("\n            （二）您或您的孩子在使用我们的产品及服务过程中，我们为向您或者您的孩子提供我们的产品及服务（如为您的账户提供安全保障等）目的，我们可能还会收集和使用其他儿童个人信息，有关具体的使用目的、收集个人信息的范围以及拒绝提供相应信息的后果请您查阅《隐私政策》“我们如何收集和使用您的个人信息”章节进行详细了解。\n        ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"text-style"},[_vm._v("此外，我们也会通过Cookies、SDK等同类技术自动收集您或您孩子的个人信息，具体请您查阅《隐私政策》“我们如何使用Cookie和同类技术”部分进行详细了解。")]),_vm._v("\n            如我们需要超出上述范围收集和使用儿童个人信息，我们将再次征得监护人的同意。\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            请您注意，绝大多数情形下我们无法识别且不会判断收集和处理的个人信息是否属于儿童个人信息，我们将按照《隐私政策》收集和处理用户的个人信息。\n        ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"text-style"},[_vm._v("（三）征得授权同意的例外")])]),_vm._v(" "),_c('p',[_vm._v("\n            根据相关法律法规规定，以下情形中收集儿童的信息无需征得儿童监护人的授权同意：\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            1、与我们履行法律法规规定的义务相关的；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            2、与国家安全、国防安全、公共安全、公共卫生、重大公共利益有关的；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            3、与犯罪侦查、起诉、审判和判决执行等有关的；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            4、出于维护儿童的生命、财产等重大合法权益但又很难得到监护人同意的；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            5、所收集的信息是儿童或监护人自行向社会公众公开的；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            6、从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            7、根据与您或您的孩子签订和履行相关协议或其他书面文件所必需的；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            8、用于维护我们的产品及服务的安全稳定运行所必需的，例如发现、处置我们的产品及服务的故障；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            9、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            10、法律法规规定的其他情形。\n        ")]),_vm._v(" "),_c('p',[_vm._v("二、我们如何共享、转让、公开披露儿童个人信息")]),_vm._v(" "),_c('p',[_vm._v("\n            我们承诺对儿童个人信息进行严格保密，仅在符合本政策说明和您明确授权同意的情况下对外共享儿童个人信息。为了提升信息处理效率，降低信息处理成本，或提高信息处理准确性，我们可能会委托有能力的我们的关联公司或其他专业机构代表我们来处理儿童个人信息，具体请参见《隐私政策》“我们如何共享、转让、公开披露您的信息”部分。\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            除了《隐私政策》“我们如何共享、转让、公开披露您的个人信息”部分所述的内容外，对于儿童个人信息，我们还将会采取如下措施来保护儿童个人信息在共享、转让和公开披露过程中的安全：\n        ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"text-style"},[_vm._v("1、如果为了本政策所述目的而需要将儿童个人信息共享至第三方，我们将评估该第三方收集儿童个人信息的合法性、正当性、必要性。")])]),_vm._v(" "),_c('p',[_vm._v("\n            2、我们将要求第三方对儿童个人信息采取保护措施，并且严格遵守相关法律法规与监管要求。我们会要求接收儿童个人信息的第三方遵守严格的保密义务及采取有效的保密措施，禁止其将这些儿童个人信息用于未经儿童及其监护人授权的用途，并要求受托公司依法履行以下义务：\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            （1）按照法律、行政法规的规定和我们的要求处理儿童个人信息；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            （2）协助我们回应儿童监护人提出的申请；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            （3）采取措施保障信息安全，并在发生儿童个人信息泄露安全事件时，及时向我们反馈；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            （4）委托关系解除时及时删除儿童个人信息；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            （5）不得转委托；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            （6）其他依法应当履行的儿童个人信息保护义务。\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            3、另外，我们会按照法律法规的要求征得您的同意，或确认第三方已经征得您同意。\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            三、我们如何储存儿童个人信息\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            （一）我们在中华人民共和国境内运营中收集和产生的儿童个人信息，将存储在中国境内。以下情形下，我们会在履行了法律规定的义务后，向境外的组织或个人提供儿童的个人信息：\n        ")]),_vm._v(" "),_c('p',[_vm._v("1、适用的法律有明确规定；")]),_vm._v(" "),_c('p',[_vm._v("2、获得您的明确授权；")]),_vm._v(" "),_c('p',[_vm._v("3、您或者您的孩子通过互联网进行跨境交易等个人主动行为。")]),_vm._v(" "),_c('p',[_vm._v("针对以上情形，我们会通过合同等形式确保以不低于本政策规定的程度保护儿童的个人信息。")]),_vm._v(" "),_c('p',[_vm._v("（二）我们会采取合理可行的措施，尽力避免收集和处理无关的儿童的个人信息。我们只会在达成本政策所述目的所需的期限内保留儿童的个人信息，除非法律有强制的留存要求。关于我们如何确定儿童个人信息存储期限请参见《隐私政策》“我们如何保护您的信息”。\n            "),_c('span',{staticClass:"text-style"},[_vm._v("如我们终止服务或运营，我们将及时停止继续收集儿童个人信息的活动，同时会遵守相关法律法规要求提前向监护人通知，并在终止服务或运营后对儿童的个人信息进行删除或匿名化处理，但法律法规或监管部门另有规定的除外。")])]),_vm._v(" "),_c('p',[_vm._v("四、我们如何保护儿童个人信息")]),_vm._v(" "),_c('p',[_vm._v("我们非常重视儿童的隐私安全，并采取一切合理可行的措施，保护儿童个人信息：")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"text-style"},[_vm._v("（一）我们会严格控制儿童个人信息的访问权限，对可能接触到儿童个人信息的工作人员采取最小够用授权原则，并采取技术措施对工作人员处理儿童个人信息的行为进行记录和管控，避免违法复制、下载儿童个人信息。")])]),_vm._v(" "),_c('p',[_vm._v("（二）在不幸发生儿童个人信息安全事件后，我们将按照法律法规的要求，及时向儿童及其监护人告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、儿童及其监护人可自主防范和降低风险的建议、对儿童及其监护人的补救措施等。我们将及时将事件相关情况以App推送通知、短消息等方式告知儿童及其监护人。难以逐一告知时，我们会采取合理、有效的方式发布相关警示信息。同时，我们还将按照监管部门要求，主动上报儿童个人信息安全事件的处置情况。若儿童及其监护人的合法权益受损，我们将承担相应的法律责任。")]),_vm._v(" "),_c('p',[_vm._v("（三）如您希望了解更多，请查阅《隐私政策》“我们如何保护您的信息”章节，详细了解我们如何采取了哪些措施保护儿童个人信息。")]),_vm._v(" "),_c('p',[_vm._v("五、如何管理儿童个人信息")]),_vm._v(" "),_c('p',[_vm._v("（一）为了您或您的孩子在使用我们的产品及服务期间可以更加便捷地访问和管理您孩子的个人信息，同时保障注销账户的权利，我们在客户端中为您和您的孩子提供了相应的操作设置，您和您的孩子可以按照《隐私政策》中的“您如何管理您的信息”章节指引进行操作。")]),_vm._v(" "),_c('p',[_vm._v("（二）下列情形下，您或您的孩子可以通过《隐私政策》“如何联系我们”所列的渠道联系我们，要求删除相应的儿童个人信息：")]),_vm._v(" "),_c('p',[_vm._v("1、我们违反法律、行政法规的规定或者双方的约定收集、存储、使用、对外提供儿童个人信息的；")]),_vm._v(" "),_c('p',[_vm._v("\n            2、超出目的范围或者必要期限收集、存储、使用、对外提供儿童个人信息的；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            3、您撤回同意的；\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            4、您或您的孩子通过注销等方式终止使用产品或者服务的。\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            六、本政策的修订\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            我们可能适时修订本隐私政策的条款，本隐私政策为《好分数辅导隐私政策》的重要组成部分。对于重大变更，我们会提供更显著的通知，您如果不同意该等变更，可以选择停止使用好分数辅导的产品或服务；如您仍然继续使用好分数辅导的产品或服务，即表示同意受经修订的本政策的约束。\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            七、如何联系我们\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            如您和您的孩子对本隐私政策有任何疑问，或对于儿童个人信息处理存在任何投诉、意见，请通过以下渠道联系我们，我们将在收到问题、意见或建议，并验证监护人和/或儿童身份后的十五天内回复您的请求：\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            至远无限教育科技（北京）有限公司\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            地址：北京市海淀区东升科技园学院八号\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            邮箱marketing@aiyunxiao.com\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            电话：400-8180-190\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            需注意的是，我们可能不会回复与本政策或与个人信息保护无关的问题。\n        ")])])}]


/***/ }),

/***/ "KQPB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppHeader__ = __webpack_require__("HclP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppFooter__ = __webpack_require__("5Yo1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AppHeader: __WEBPACK_IMPORTED_MODULE_0__AppHeader__["a" /* default */],
        AppFooter: __WEBPACK_IMPORTED_MODULE_1__AppFooter__["a" /* default */]
    }
});

/***/ }),

/***/ "s4S5":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Bx9n");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("rjj0").default
var update = add("ac75efa6", content, true, {});

/***/ }),

/***/ "uR8B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChildPrivaryPolicy_vue__ = __webpack_require__("KQPB");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d0fcf96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChildPrivaryPolicy_vue__ = __webpack_require__("I1ew");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("s4S5")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d0fcf96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChildPrivaryPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d0fcf96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChildPrivaryPolicy_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d0fcf96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChildPrivaryPolicy_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/59.1ae11ce0a1596976a880.js